var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"video",staticStyle:{"oveflow":"hidden"}},[_c('video',{attrs:{"src":_vm.data.link,"controls":"controls"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }